// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__KkYTg","checkbox_container":"Checkbox_checkbox_container__8IYxa"};